/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("DummyRadioGroupWidget", ["RadioGroupWidget", "WidgetFactory"], function (context, cls) {
  /**
   * RadioGroup widget.
   * @class DummyRadioGroupWidget
   * @memberOf classes
   * @extends classes.RadioGroupWidget
   */
  cls.DummyRadioGroupWidget = context.oo.Class(cls.RadioGroupWidget, function ($super) {
    return /** @lends classes.DummyRadioGroupWidget.prototype */ {
      __name: "DummyRadioGroupWidget",
      __templateName: "RadioGroupWidget",

      /**
       * @inheritDoc
       */
      getValue: function () {
        let value = "";
        const children = cls.DOMElementHelper.childrenExcept(this._element, this.__charMeasurer);
        for (const item of children) {
          if (item.getElementsByClassName("zmdi")[0].classList.contains("checked")) {
            if (value.length !== 0) {
              value += "|";
            }
            value += item.dataset.value ?? null;
          }
        }
        return value;
      },

      /**
       * On previous handler : action to do when we want to go to previous value
       * @private
       */
      _onPrevious: function () {
        this._currentlyAimedIndex -= 1;
        if (this._currentlyAimedIndex < 0) {
          this._currentlyAimedIndex = this.getItemElements().length - 1;
        }

        this._updateVisual(this.getValue(), this._currentlyAimedIndex);
      },

      /**
       * On next handler : action to do when we want to go to next value
       * @private
       */
      _onNext: function () {
        this._currentlyAimedIndex += 1;
        if (this._currentlyAimedIndex >= this.getItemElements().length) {
          this._currentlyAimedIndex = 0;
        }

        this._updateVisual(this.getValue(), this._currentlyAimedIndex);
      },

      /**
       * @inheritDoc
       */
      _setValue: function (value) {
        // Find the last modified index to set the currentlyAimedIndex for correct focus
        const previousValues = this.getValue().split("|");
        const newValues = String(value).split("|");
        const findOddValue = (largerArray, smallerArray) => {
          for (let val in largerArray) {
            if (!smallerArray.includes(val)) {
              return val;
            }
          }
          return "";
        };
        let oddValue = "";
        if (previousValues.length > newValues.length) {
          oddValue = findOddValue(previousValues, newValues);
        } else {
          oddValue = findOddValue(newValues, previousValues);
        }
        const indexOfOddValue = this._indexOf(oddValue);
        this._currentlyAimedIndex = indexOfOddValue === -1 ? this._currentlyAimedIndex : indexOfOddValue;
        this._value = value;
        this._updateVisual(value, this._currentlyAimedIndex);
      },

      /**
       * Update the UI, with the value for the given index.
       * !! This method don't change the value of the widget class !!
       * @param {number} index - index of the value
       * @param {boolean} allowKeepNull If true, the value will stay null if it was null before (used for previous and next)
       * (Not used in CONSTRUCT)
       * @returns {string} The value corresponding to the visual
       * @private
       */
      _getIndexValue: function (index, allowKeepNull) {
        const currentValues = this.getValue();

        if (!this.isEnabled()) {
          return currentValues;
        }
        const childItem = this.getItemElements()[index];

        if (childItem === undefined) {
          return currentValues;
        }

        const wantedValue = childItem.dataset.value ?? null;
        if (!wantedValue) {
          return currentValues;
        }

        let newValue = "";
        // On unselect, remove wantedValue from currently selected values
        if (currentValues.includes(wantedValue)) {
          let values = currentValues.split("|");
          for (let value of values) {
            if (value === wantedValue) {
              continue;
            }
            if (newValue.length > 0) {
              newValue += "|";
            }
            newValue += value;
          }
          return newValue;
        }

        // Append wantedValue to values
        newValue = currentValues;
        if (newValue.length > 0) {
          newValue += "|";
        }
        newValue += wantedValue;

        return newValue;
      },

      /**
       * Manage RadioGroup visual depending on the values given in parameters
       * @param {string} checkedValues The checked values, used to find the item to check. If null, no item will be checked
       * @param {number|undefined} aimedIndex The index of the aimed item, if set to undefined, it will be the same as the checkedValue item.
       */
      _updateVisual: function (checkedValues, aimedIndex) {
        const values = String(checkedValues).split("|");

        this.getItemElements().forEach((item, index) => {
          const itemValue = item.dataset.value ?? null;
          // Foreach children, toggle 'checked', and 'unchecked' classes
          const boxElement = item.getElementsByClassName(this.getBEMPartName("itemIcon"))[0];
          cls.DOMElementHelper.toggleClasses(
            boxElement,
            values.includes(itemValue),
            context.constants.widgetCssClasses.checked,
            context.constants.widgetCssClasses.unchecked
          );
          const itemIsSelected = index === aimedIndex;
          cls.DOMElementHelper.toggleClasses(item, itemIsSelected, context.constants.widgetCssClasses.isSelected);
          item.setAttribute("aria-checked", String(values.includes(itemValue)));
        });
      }
    };
  });
  cls.WidgetFactory.registerBuilder("DummyRadioGroup", cls.DummyRadioGroupWidget);
});
